import {ModalFormFieldTypes} from 'components/formItems/FormGroup/FormGroup';
import {numberRules} from 'utils/formRules';

const fields: ModalFormFieldTypes[] = [
	{
		type: 'title',
		label: 'Ծնողի տվյալներ (հայր)'
	},
	{
		name: 'fatherNameSurname',
		label: 'Անուն, Ազգանուն',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Անուն, Ազգանուն'
		},
		type: 'text'
	},
	{
		name: 'fatherTelEmail',
		label: 'Էլ․ փոստ / Հեռախոս',
		inputProps: {
			placeholder: 'Էլ․ փոստ / Հեռախոս'
		},
		type: 'text',
		isRequired: false
	},
	{
		name: 'fatherProfession',
		label: 'Մասնագիտություն',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Մասնագիտություն'
		},
		type: 'text',
		isRequired: false
	},
	{
		name: 'fatherCompany',
		label: 'Կազմակերպության անվանում',
		inputProps: {
			placeholder: 'Կազմակերպության անվանում'
		},
		type: 'text',
		onlyArmenian: true,
		isRequired: false
	},
	{
		type: 'divider'
	},
	{
		type: 'title',
		label: 'Ծնողի տվյալներ (մայր)'
	},
	{
		name: 'motherNameSurname',
		label: 'Անուն, Ազգանուն',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Անուն, Ազգանուն'
		},
		type: 'text'
	},
	{
		name: 'motherTelEmail',
		label: 'Էլ․ փոստ / Հեռախոս',
		inputProps: {
			placeholder: 'Էլ․ փոստ / Հեռախոս'
		},
		type: 'text',
		isRequired: false
	},
	{
		name: 'motherProfession',
		label: 'Մասնագիտություն',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Մասնագիտություն'
		},
		type: 'text',
		isRequired: false
	},
	{
		name: 'motherCompany',
		label: 'Կազմակերպության անվանում',
		inputProps: {
			placeholder: 'Կազմակերպության անվանում'
		},
		type: 'text',
		onlyArmenian: true,
		isRequired: false
	},
	{
		type: 'divider'
	},
	{
		type: 'title',
		label: 'Արտակարգ իրավիճակի համար խնդրում ենք թողնել կոնտակտային անձի տվյալներ'
	},
	{
		name: 'extraContactName',
		label: 'Անուն, Ազգանուն',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Անուն, Ազգանուն'
		},
		type: 'text'
	},
	{
		name: 'extraContactAddress',
		label: 'Հասցե',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Հասցե'
		},
		type: 'text'
	},
	{
		name: 'extraContactTel',
		type: 'text',
		label: 'Հեռախոս',
		inputProps: {
			placeholder: 'Հեռախոս',
			addonBefore: '+'
		},
		rules: [numberRules]
	},
	{
		name: 'extraContactType',
		label: 'Բարեկամական կապ',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Բարեկամական կապ'
		},
		type: 'text'
	}
];
export default fields;
